import { ToastContainer } from 'react-toastify';
import './App.css';
import CustomCursor from './components/ui/cursor/Cursor';
import AppRoutes from './routes/AppRoutes';
import ScrollToTopBtn from './components/ui/buttons/scroll-to-top/ScrollToTopBtn';

function App() {
  return (
    <>
      <div className="App">
        <AppRoutes />
      </div>

      <CustomCursor />

      <ScrollToTopBtn />

      <ToastContainer 
        position='top-center'
        pauseOnFocusLoss
        pauseOnHover
        theme='light'
        autoClose={4000}
        hideProgressBar={false}
        closeOnClick
        draggable={false}
        toastClassName="neurora-toast"
        progressClassName="neurora-toast__progress"
      />
    </>
  );
}

export default App;
